import React, { ChangeEvent, ReactNode } from "react";

import styles from "./RadioButton.module.scss";

interface RadioButtonProps {
  value: number;
  selected: number;
  children: ReactNode;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  value,
  selected,
  children,
  handleChange,
}) => {
  return (
    <label className={styles.radioButton} htmlFor={`class-${value}`}>
      <p className={styles.name}>{children}</p>
      <div className={styles.inputWrapper}>
        <input
          type="radio"
          name="class"
          value={value}
          id={`class-${value}`}
          checked={selected === value}
          onChange={handleChange}
        />
        <span className={styles.circle} />
      </div>
    </label>
  );
};

export default RadioButton;
